import './jackscawthon/style';
import FormStructure from './jackscawthon/form_structure';

export default FormStructure;